var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 8C70.5914 8 88.5 25.9086 88.5 48C88.5 70.0914 70.5914 88 48.5 88C26.4086 88 8.5 70.0914 8.5 48C8.5 25.9086 26.4086 8 48.5 8ZM43.9463 53.1133L38.3867 47.5537L36.5 49.4404L43.9463 56.8867L59.9463 40.8867L58.0596 39L43.9463 53.1133Z",
    fill: "#50B848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.a78e8f4bdc683f183792d32e5d98d085.svg";
export { ForwardRef as ReactComponent };